module.exports = __webpack_public_path__ + "static/media/5.5c43eae5.jpg";